<template>
  <el-main class="systemNotification">
    <div class="notification-list">
      <div class="notification-item" v-for="(item, index) in notificationList" :key="index">
        <div class="title-time">
          <div class="title">{{ item.title }}</div>
          <div class="time"><span>{{ $t('operate.name90') }}</span> <span>{{ item.time }}</span></div>
        </div>
        <div class="content">
          {{ item.content }}
        </div>
      </div>
    </div>

    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </el-main>
</template>
<script>
export default {
  data() {
    return {
      queryInfo: {
        loginName: '',
        pageNumber: 1,
        pageSize: 10
      },
      total: 0,
      notificationList: [
        { title: '通知标题', time: '通知时间', content: '通知内容' },
        { title: '通知标题', time: '通知时间', content: '通知内容' },
        { title: '通知标题', time: '通知时间', content: '通知内容' }
      ]
    }
  },
  created() {},
  mounted() {},

  methods: {
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      // this.getBaseBike()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      // this.getBaseBike()
    }
  }
}
</script>
<style lang="scss" scoped>
.systemNotification {
  display: flex;
  flex-direction: column;
  .notification-list {
    display: flex;
    flex-direction: column;
    .notification-item {
      display: flex;
      flex-direction: column;
      border: 1px solid rgba(121, 121, 121, 1);
      margin-bottom: 15px;

      .title-time {
        display: flex;
        justify-content: space-between;
        background-color: rgba(242, 242, 242, 1);
        height: 40px;
        padding: 0px 15px;
        align-items: center;
        .title {
          font-size: 18px;
        }
        .time {
          font-size: 14px;
        }
      }
      .content {
        margin-top: 5px;
        font-size: 14px;
        padding: 0px 15px;
        line-height: 20px;
        min-height: 60px;
      }
    }
  }
}
</style>
